import $ from 'jquery';

function CACLoginPage() {
  const heroContent =
    '<article class="login-hero-pane"><h1>Login</h1> <p class="description">By signing in, you are agreeing to the U.S. DoD Terms of Service and user agreement.</p></article>';

  if ($('#dnn_ctr_Login_DMAAuthentication').length || $('#dnn_ctr_Login_DNN').length) {
    $('#dnn_HeaderPaneTop').removeClass('DNNEmptyPane').prepend(heroContent);
  }
}

export default CACLoginPage;
